import { useCountryInfo } from 'legacy/lut/hooks/useCountryInfo'
import { useCallback, useMemo } from 'react'

import { Market } from 'clickNgo/configs/geo'
import { IPartnerLegalRequest } from 'clickNgo/entities/partner/models'
import { IPartnerFormBasic } from 'clickNgo/entities/partner/models/form/basic'
import { TPartnerFormKeys } from 'clickNgo/entities/partner/models/form/common'
import { IPartnerFormLegal } from 'clickNgo/entities/partner/models/form/legal'
import { IAttachment } from 'clickNgo/models/file'
import { useGetFormData } from 'cng-common/features/form'

import { partnerEditorTranslation } from '../../../../translation'

interface IUsePartnerBasicInfoValidationParams {
  formKeys: TPartnerFormKeys
  isDisabled?: boolean
}

const legalAddressFields: Array<Partial<keyof IPartnerLegalRequest>> = [
  'legalAddressLine1',
  'legalAddressLine2',
  'legalAddressLine3',
  'legalCity',
  'legalCountry',
  'legalZipCode',
  'legalState',
]

export const usePartnerAttachmentsValidation = ({
  formKeys,
  isDisabled,
}: IUsePartnerBasicInfoValidationParams) => {
  const [basicFormData] = useGetFormData<IPartnerFormBasic>(formKeys.basic)
  const [legalFormData] = useGetFormData<IPartnerFormLegal>(formKeys.legal)

  const countryInfo = useCountryInfo(basicFormData.formData.country)
  const isValidationEnabled = !isDisabled
  const isSuitableMarket = useMemo(
    () => countryInfo && countryInfo.market !== Market.NORTH_AMERICA,
    [countryInfo]
  )
  const wasLegalAddressUpdated = useMemo(
    () => legalAddressFields.some((field) => legalFormData.modifiedFields.includes(field)),
    [legalFormData.modifiedFields]
  )

  const isAttachmentRequired = isSuitableMarket && wasLegalAddressUpdated

  const onAttachmentsValidate = useCallback(
    (attachments: IAttachment[]) => {
      const isFileListEmpty = attachments.length === 0
      if (isValidationEnabled && isFileListEmpty && isAttachmentRequired) {
        return partnerEditorTranslation.validation.attachments
      }
      return ''
    },
    [isAttachmentRequired, isValidationEnabled]
  )

  return { onAttachmentsValidate }
}
